module.exports = __webpack_public_path__ + "static/media/Qt.99e614b7.png";